var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9975 17.7485C8.5875 17.7485 8.2475 17.4085 8.2475 16.9985V12.8085L7.5275 13.5285C7.2375 13.8185 6.7575 13.8185 6.4675 13.5285C6.1775 13.2385 6.1775 12.7585 6.4675 12.4685L8.4675 10.4685C8.6775 10.2585 9.0075 10.1885 9.2875 10.3085C9.5675 10.4185 9.7475 10.6985 9.7475 10.9985V16.9985C9.7475 17.4085 9.4075 17.7485 8.9975 17.7485Z",
    fill: "#5E2540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9975 13.7514C10.8075 13.7514 10.6175 13.6814 10.4675 13.5314L8.4675 11.5314C8.1775 11.2414 8.1775 10.7614 8.4675 10.4714C8.7575 10.1814 9.2375 10.1814 9.5275 10.4714L11.5275 12.4714C11.8175 12.7614 11.8175 13.2414 11.5275 13.5314C11.3775 13.6814 11.1875 13.7514 10.9975 13.7514Z",
    fill: "#5E2540"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z",
    fill: "#5E2540"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.7485H18C14.58 10.7485 13.25 9.41852 13.25 5.99852V1.99852C13.25 1.69852 13.43 1.41852 13.71 1.30852C13.99 1.18852 14.31 1.25852 14.53 1.46852L22.53 9.46852C22.74 9.67852 22.81 10.0085 22.69 10.2885C22.57 10.5685 22.3 10.7485 22 10.7485ZM14.75 3.80852V5.99852C14.75 8.57852 15.42 9.24852 18 9.24852H20.19L14.75 3.80852Z",
    fill: "#5E2540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.b45bce5d8e0ae404e3bfa77f84253956.svg";
export { ForwardRef as ReactComponent };